module.exports = __webpack_public_path__ + "img/icon3.761c1872.png";